import { z } from 'zod';
import { ROUTE_CYO } from '@hungryroot/page-cyo';
import { ROUTE_SIGN_UP } from '@hungryroot/page-signup';
import { ROUTE_PLAN_PRECHECKOUT } from '@hungryroot/plan';
import { allQuizRoutes } from '@hungryroot/quiz';

export const BUILDING_PATH = '/quiz/building/';
const ROUTE_CHECKOUT_SHIPPING = '/checkout/shipping/';
const ROUTE_HOMEPAGE = '/';
const ROUTE_CHECKOUT_PAYMENT = '/checkout/payment/';

const preSignUpRoutes = [
  ROUTE_HOMEPAGE,
  BUILDING_PATH,
  ROUTE_SIGN_UP,
  ...allQuizRoutes,
] as const;

export const postSignUpRoutes = [
  ROUTE_CYO,
  ROUTE_CHECKOUT_SHIPPING,
  ROUTE_CHECKOUT_PAYMENT,
  ROUTE_PLAN_PRECHECKOUT,
] as const;

// All of the funnel routes
// This is not an ordered list
// Its just a list of all the routes in the funnel
const funnelRoutes = [...preSignUpRoutes, ...postSignUpRoutes] as const;

export type AllFunnelRoutes = (typeof funnelRoutes)[number];

export const funnelRoutesSchema = z.enum(funnelRoutes);
